module.exports={
  "Description": "WF : 986NN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^986[0-9]{2}$",
  "TestData": {
    "Valid": [
      "98600",
      "98690"
    ],
    "Invalid": [
      "9862",
      "986999",
	  "98990",
	  "098690"
    ]
  }
}